import {
  anInsight,
  aSignal,
  mockInsightSignalsQueryQuery,
  SignalFragment,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockInsightSignalsQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insight: {
            ...anInsight(),
            signals: [aSignal() as SignalFragment],
          },
        },
      });
    }
  ),
];
